<template>
  <div>
    <div class="text-center mb-5">
      <h1 class="mb-5">
        <!-- <img src="resources/images/pulih-purple-withtext.svg" class="mr-2" alt="PULIH" /> -->
        <strong>Welcome to {{ settings.logo }}</strong>
      </h1>
    </div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-3">
        <strong>Sign in to your account</strong>
      </div>
      <!-- <div class="mb-4">
        <a-radio-group
          v-model="type"
          buttonStyle="solid"
          class="d-flex flex-wrap justify-content-start"
        >
          <a-radio-button class="my-1" value="admin">Admin</a-radio-button>
          <a-radio-button class="my-1" value="verificator"
            >Verificator</a-radio-button
          >
          <a-radio-button class="my-1" value="tagrisso"
            >Tagrisso</a-radio-button
          >
          <a-radio-button class="my-1" value="faslodex"
            >Faslodex</a-radio-button
          >
          <a-radio-button class="my-1" value="lynparza"
            >Lynparza</a-radio-button
          >
          <a-radio-button class="my-1" value="imfinzi">Imfinzi</a-radio-button>
          <a-radio-button class="my-1" value="calquence"
            >Calquence</a-radio-button
          >
        </a-radio-group>
      </div> -->
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="[
              'email',
              {
                initialValue: '',
                rules: [
                  { required: true, message: 'Please input your username!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input-password
            size="large"
            placeholder="Password"
            v-decorator="[
              'password',
              {
                initialValue: '',
                rules: [
                  { required: true, message: 'Please input your Password!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center w-100"
          :loading="loading"
        >
          <strong>Sign in</strong>
        </a-button>
      </a-form>
      <router-link
        to="/auth/forgot-password"
        class="kit__utils__link font-size-16 float-right text-right"
        >Forgot password?</router-link
      >
    </div>
    <!-- <div class="text-center pt-2 mb-auto">
      <span class="mr-2">Don't have an account?</span>
      <router-link to="/auth/register" class="kit__utils__link font-size-16">Sign up</router-link>
    </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'CuiLogin',
  computed: {
    ...mapState(['settings']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      type: 'admin',
    }
  },
  methods: {
    changeAuthProvider(value) {
      this.$store.commit('CHANGE_SETTING', { setting: 'authProvider', value })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        // console.log(values, this.type)
        if (!err) {
          // if (this.type === 'verificator') {
          //   this.$store.dispatch('user/LOGINVERIFICATOR', {
          //     ...values,
          //     role: 'verificator',
          //   })
          // } else {
          this.$store.dispatch('user/LOGIN', {
            payload: { ...values },
          })
          // }
        } else {
          console.log(err)
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
